import React, {Component} from 'react';
import Scanner from './Scanner';

export class CodeBar extends Component{

    constructor(){
        super()
        this.state = {
            scanning: false,
        }  

        this.onDetected = this.onDetected.bind(this);
    }

    componentDidMount(){
        this.onScan()
    }

    onScan = () => {
        this.setState({scanning: !this.state.scanning});
    }
    
    onDetected(result) {

        this.props.onScan(result)
    }

    render() {
        return (
            <div>
                {this.state.scanning ? <Scanner onDetected={this.onDetected}/> : null}
            </div>
        );
    }    
}

export default CodeBar;
